import { AlertService } from '../../shared/services/alert.service';
import { Location } from '@angular/common';
import { OnInit } from '@angular/core';
import { AssessmentService } from '../../shared/services/assessment.service';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionType } from "../../shared/models/question-type";
import { QuestionFactoryService } from "../../shared/services/question-factory.service";
var QuestionNewComponent = /** @class */ (function () {
    function QuestionNewComponent(assessmentService, questionFactory, alertService, location, router, route) {
        this.assessmentService = assessmentService;
        this.questionFactory = questionFactory;
        this.alertService = alertService;
        this.location = location;
        this.router = router;
        this.route = route;
        this.SAVE_TIME = 1500;
        this.ERROR_MESSAGE_TIME = 3000;
        // make the default to be multiple choice.
        this._currentType = QuestionType.MultipleChoice;
        this._question = this.getNewQuestion();
    }
    QuestionNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var assessmentUid = params['uid'];
            var setId = params['setId'];
            _this.assessmentService.getAssessment(assessmentUid)
                .then(function (assessment) {
                _this.assessment = assessment;
                _this.questionSet = assessment.question_sets.find(function (s) { return s.id == setId; });
                if (!_this.questionSet) {
                    // TODO: stephen should we navigate back?? or do some kind of 404?
                    _this.router.navigate(["not-found"]);
                }
                _this.setScaleIfSingle(_this.question, _this.assessment);
            })
                .catch(function (error) {
                console.error(error);
                _this.router.navigate(["not-found"]);
            });
        });
    };
    QuestionNewComponent.prototype.setScaleIfSingle = function (question, assessment) {
        if (assessment && assessment.scales && assessment.scales.length == 1) {
            question.assessment_scale = this.assessment.scales[0];
        }
    };
    QuestionNewComponent.prototype.updateType = function (event) {
        var select = event.target;
        this._currentType = +select.value;
        var newQuestion = this.getNewQuestion();
        newQuestion.prompt = this.question.prompt;
        newQuestion.is_reversed = this.question.is_reversed;
        this._question = newQuestion;
    };
    Object.defineProperty(QuestionNewComponent.prototype, "DisplayTypes", {
        get: function () {
            var _this = this;
            var types = [
                { value: QuestionType.MultipleChoice, name: "Multiple Choice", isSelected: false },
                { value: QuestionType.Checklist, name: QuestionType[QuestionType.Checklist], isSelected: false },
                { value: QuestionType.Textbox, name: QuestionType[QuestionType.Textbox], isSelected: false },
                { value: QuestionType.SingleChoice, name: "Single Choice", isSelected: false }
            ];
            types.forEach(function (t) { return t.isSelected = t.value == _this._currentType; });
            return types;
        },
        enumerable: true,
        configurable: true
    });
    QuestionNewComponent.prototype.getNewQuestion = function () {
        var question = this.questionFactory.createQuestionForType(this._currentType);
        question.id = this.assessmentService.newId();
        this.setScaleIfSingle(question, this.assessment);
        return question;
    };
    Object.defineProperty(QuestionNewComponent.prototype, "scales", {
        get: function () {
            if (this.assessment) {
                return this.assessment.scales;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionNewComponent.prototype, "question", {
        get: function () {
            return this._question;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionNewComponent.prototype, "labels", {
        get: function () {
            return (this.questionSet ? this.questionSet.labels : []);
        },
        enumerable: true,
        configurable: true
    });
    QuestionNewComponent.prototype.isMultipleChoiceQuestion = function () {
        return this._currentType == QuestionType.MultipleChoice;
    };
    QuestionNewComponent.prototype.saveQuestion = function (question) {
        var _this = this;
        this.questionSet.addQuestion(question);
        this.isSaving = true;
        return this.assessmentService.saveAssessment(this.assessment).then(function (assessment) {
            _this.alertService.success("Question saved", _this.SAVE_TIME);
            _this.isSaving = false;
            return question;
        }).catch(function (error) {
            _this.isSaving = false;
            _this.alertService.error("An error occurred in saving. Please try again or contact support.", _this.ERROR_MESSAGE_TIME);
            console.error(error);
        });
    };
    QuestionNewComponent.prototype.save = function () {
        var _this = this;
        this.saveQuestion(this.question).then(function (question) {
            setTimeout(function () {
                _this.router.navigate(["../", _this.question.id, "edit"], { relativeTo: _this.route, replaceUrl: true });
            }, _this.SAVE_TIME);
        });
    };
    QuestionNewComponent.prototype.saveAndCreateNew = function () {
        var _this = this;
        this.saveQuestion(this.question).then(function (question) {
            _this._question = _this.getNewQuestion();
        });
    };
    return QuestionNewComponent;
}());
export { QuestionNewComponent };



// WEBPACK FOOTER //
// ./src/app/admin/question-new/question-new.component.ts.pre-build-optimizer.js